// packages/shared-utils/src/main/deviceConstants.ts

/**
 * Centralized device identifiers.
 *
 * Keep these in one place to avoid scattered string literals ("keyboard"/"mouse")
 * and magic numbers across the codebase.
 */
export enum DeviceType {
  Keyboard = "keyboard",
  Mouse = "mouse",
  Earphone = "earphone",
}

export const isDeviceType = (value: unknown): value is DeviceType =>
  value === DeviceType.Keyboard ||
  value === DeviceType.Mouse ||
  value === DeviceType.Earphone;

/** 传感器型号兜底最大 DPI（3950 / 3395 / 3315 / 3311 / 8925 等） */
export function dpiMax(sensor: string): number {
  switch (String(sensor).trim()) {
    case "3955":
    case "3955A":
      return 50000;
    case "3950":
      return 42000;
    case "3395":
      return 30000;
    case "3315":
      return 16000;
    case "3315A":
      return 26000;
    case "3311":
      return 12000;
    case "3311A":
      return 24000;
    case "8925":
      return 24000;
    case "S203":
      return 12800;
    default:
      return 42000;
  }
}
